import { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { AppContext } from '@edx/frontend-platform/react';

import { GET_DISCOVER_PROGRAMS } from '../queries/discoverPrograms';

export const useDiscoverPrograms = (enabled = true) => {
  const { authenticatedUser } = useContext(AppContext);
  const userId = authenticatedUser?.id ?? authenticatedUser?.userId;

  const { data, loading, error } = useQuery(GET_DISCOVER_PROGRAMS, {
    variables: { userId },
    skip: !userId || !enabled,
  });

  return {
    discoverPrograms: data?.discoverPrograms || [],
    loading,
    error,
  };
};
